<template>
  <div class="page-container">
    <div class="table-wrapper">
      <div class="table-header">
        <div style="display:flex;align-items:center;gap:12px;">
          <span class="table-title">真实交易</span>
          <span style="font-size:13px;color:#9ca3af;">共 <b style="color:#1a2236;">{{ total }}</b> {{ tab==='positions' ? '条持仓' : tab==='orders' ? '条委托' : tab==='deals' ? '条成交' : '条流水' }}</span>
        </div>
        <div class="table-actions">
          <button class="btn btn-secondary btn-sm" @click="refresh">🔄 刷新</button>
          <button v-auth="'business:trading:export'" class="btn btn-secondary btn-sm" @click="handleExport">📥 导出</button>
        </div>
      </div>

      <el-tabs v-model="tab" @tab-click="onTabClick">
        <el-tab-pane label="持仓记录" name="positions"></el-tab-pane>
        <el-tab-pane label="委托记录" name="orders"></el-tab-pane>
        <el-tab-pane label="交易历史" name="deals"></el-tab-pane>
        <el-tab-pane label="资金流水" name="fundFlow"></el-tab-pane>
      </el-tabs>

      <el-form :inline="true" size="small">
        <el-form-item label="用户ID"><el-input v-model="search.customerNo" placeholder="用户ID" clearable style="width:110px;"></el-input></el-form-item>
        <el-form-item label="姓名"><el-input v-model="search.name" placeholder="姓名" clearable style="width:100px;"></el-input></el-form-item>
        <el-form-item label="交易账号"><el-input v-model="search.accountNo" placeholder="真实账号" clearable style="width:120px;"></el-input></el-form-item>
        <el-form-item v-if="tab!=='fundFlow'" label="交易品种">
          <el-select v-model="search.symbol" placeholder="全部" clearable style="width:110px;">
            <el-option v-for="s in symbolOptions" :key="s" :label="s" :value="s"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易组别">
          <el-select v-model="search.groupName" placeholder="全部" clearable style="width:170px;">
            <el-option v-for="g in groupOptions" :key="g.value" :label="g.label" :value="g.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="tab!=='fundFlow'" label="买卖方向">
          <el-select v-model="search.action" placeholder="全部" clearable style="width:90px;">
            <el-option label="买入" :value="0"></el-option><el-option label="卖出" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="tab!=='fundFlow'" :label="tab==='positions' ? '持仓单号' : tab==='orders' ? '委托单号' : '成交单号'">
          <el-input v-model="search.orderNo" :placeholder="tab==='positions' ? '持仓单号' : tab==='orders' ? '委托单号' : '成交单号'" clearable style="width:130px;"></el-input>
        </el-form-item>
        <el-form-item v-if="tab==='orders'" label="委托类型">
          <el-select v-model="search.type" placeholder="全部" clearable style="width:90px;">
            <el-option label="限价" :value="1"></el-option><el-option label="停损" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="tab==='orders'" label="有效期">
          <el-select v-model="search.typeTime" placeholder="全部" clearable style="width:100px;">
            <el-option label="当日" :value="1"></el-option><el-option label="当周" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="tab==='deals'" label="订单类型">
          <el-select v-model="search.dealType" placeholder="全部" clearable style="width:110px;">
            <el-option label="市价开仓" :value="1"></el-option>
            <el-option label="市价平仓" :value="2"></el-option>
            <el-option label="限价开仓" :value="3"></el-option>
            <el-option label="停损开仓" :value="4"></el-option>
            <el-option label="止损平仓" :value="5"></el-option>
            <el-option label="止盈平仓" :value="6"></el-option>
            <el-option label="系统平仓" :value="7"></el-option>
            <el-option label="强制平仓" :value="8"></el-option>
            <el-option label="手动撤单" :value="9"></el-option>
            <el-option label="系统拒绝" :value="10"></el-option>
            <el-option label="系统取消" :value="11"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="tab==='fundFlow'" label="科目类型">
          <el-select v-model="ffSearch.subjectType" placeholder="全部" clearable style="width:120px;">
            <el-option v-for="s in subjectOptions" :key="s.code" :label="s.desc" :value="s.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="tab==='fundFlow'" label="影响字段">
          <el-select v-model="ffSearch.affectField" placeholder="全部" clearable style="width:100px;">
            <el-option v-for="s in affectOptions" :key="s.code" :label="s.desc" :value="s.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="tab==='fundFlow'" label="账户类型">
          <el-select v-model="ffSearch.accountType" placeholder="全部" clearable style="width:110px;">
            <el-option label="钱包" :value="1"></el-option><el-option label="真实" :value="2"></el-option><el-option label="模拟" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="tab==='positions' ? '开仓时间' : tab==='orders' ? '挂单时间' : tab==='deals' ? '成交时间' : '发生时间'">
          <el-date-picker v-model="search.dateRange" type="daterange" range-separator="至" start-placeholder="开始" end-placeholder="结束" value-format="yyyy-MM-dd" style="width:240px;"></el-date-picker>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="searchList">搜索</el-button><el-button @click="resetSearch">重置</el-button></el-form-item>
      </el-form>

      <!-- 下面四张表是同一父节点下的 v-if 兄弟节点，必须各带 :key。
           否则切 tab 时 Vue 会把新表 patch 到旧的 el-table 实例上复用列组件，
           列的作用域插槽被串用 → 表头与单元格错位（如「科目类型」显示成别的列的值）。 -->
      <!-- 持仓记录 -->
      <el-table v-if="tab==='positions'" :key="tab" :data="posList" border size="small" v-loading="loading" style="font-size:13px;">
        <el-table-column prop="position" label="持仓单号" width="90"></el-table-column>
        <el-table-column prop="customerNo" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="name" label="姓名" width="90"></el-table-column>
        <el-table-column prop="countryCode" label="国家" width="90"></el-table-column>
        <el-table-column prop="tradeGroupName" label="交易组别" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="accountNo" label="真实账号" width="100"></el-table-column>
        <el-table-column prop="symbol" label="交易品种" width="90"></el-table-column>
        <el-table-column label="买卖方向" width="80"><template slot-scope="{row}"><span :style="{color:row.action===0?'#16a34a':'#dc2626'}">{{ row.action===0?'买入':'卖出' }}</span></template></el-table-column>
        <el-table-column label="手数" width="80"><template slot-scope="{row}">{{ volumeToLots(row.volume) }}</template></el-table-column>
        <el-table-column label="开仓价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceOpen, row.digits) }}</template></el-table-column>
        <el-table-column label="最新价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceCurrent, row.digits) }}</template></el-table-column>
        <el-table-column label="止损" width="80"><template slot-scope="{row}">{{ fmtPrice(row.priceSL, row.digits) }}</template></el-table-column>
        <el-table-column label="止盈" width="80"><template slot-scope="{row}">{{ fmtPrice(row.priceTP, row.digits) }}</template></el-table-column>
        <el-table-column label="浮动盈亏" width="100"><template slot-scope="{row}"><span :style="{color:(row.profit||0)>=0?'#16a34a':'#dc2626'}">{{ (row.profit||0).toFixed(2) }}</span></template></el-table-column>
        <el-table-column label="利息" width="80"><template slot-scope="{row}">{{ (row.storage||0).toFixed(2) }}</template></el-table-column>
        <el-table-column label="手续费" width="80"><template slot-scope="{row}">{{ (row.commission||0).toFixed(2) }}</template></el-table-column>
        <el-table-column label="保证金" width="100"><template slot-scope="{row}">{{ (row.margin||0).toFixed(2) }}</template></el-table-column>
        <el-table-column label="开仓时间" width="160"><template slot-scope="{row}">{{ fmtGmt8(row.timeCreate) }}</template></el-table-column>
        <el-table-column label="操作" width="70" fixed="right"><template slot-scope="{row}"><el-button v-auth="'business:clientAccount:close'" type="text" size="small" style="color:#f56c6c;" @click="closePosition(row)">平仓</el-button></template></el-table-column>
      </el-table>

      <!-- 委托记录 -->
      <el-table v-if="tab==='orders'" :key="tab" :data="orderList" border size="small" v-loading="loading" style="font-size:13px;">
        <el-table-column prop="order" label="委托单号" width="100"></el-table-column>
        <el-table-column prop="customerNo" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="name" label="姓名" width="90"></el-table-column>
        <el-table-column prop="countryCode" label="国家" width="90"></el-table-column>
        <el-table-column prop="tradeGroupName" label="交易组别" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="accountNo" label="真实账号" width="100"></el-table-column>
        <el-table-column prop="symbol" label="交易品种" width="90"></el-table-column>
        <el-table-column label="买卖方向" width="80"><template slot-scope="{row}"><span :style="{color:orderDirectionLabel(row.type)==='买入'?'#16a34a':'#dc2626'}">{{ orderDirectionLabel(row.type) }}</span></template></el-table-column>
        <el-table-column label="委托类型" width="100"><template slot-scope="{row}">{{ orderTypeLabel(row.type) }}</template></el-table-column>
        <el-table-column label="手数" width="80"><template slot-scope="{row}">{{ volumeToLots(row.volumeInitial) }}</template></el-table-column>
        <el-table-column label="挂单价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceOrder, row.digits) }}</template></el-table-column>
        <el-table-column label="最新价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.priceCurrent, row.digits) }}</template></el-table-column>
        <el-table-column label="止损" width="80"><template slot-scope="{row}">{{ fmtPrice(row.priceSL, row.digits) }}</template></el-table-column>
        <el-table-column label="止盈" width="80"><template slot-scope="{row}">{{ fmtPrice(row.priceTP, row.digits) }}</template></el-table-column>
        <el-table-column label="有效期" width="200" show-overflow-tooltip><template slot-scope="{row}">{{ orderTimeTypeLabel(row.typeTime, row.timeExpiration) }}</template></el-table-column>
        <el-table-column label="挂单时间" width="160"><template slot-scope="{row}">{{ fmtGmt8(row.timeSetup) }}</template></el-table-column>
        <el-table-column label="状态" width="90"><template slot-scope="{row}"><el-tag :type="orderStateType(row.state)" size="mini">{{ orderStateLabel(row.state) }}</el-tag></template></el-table-column>
        <el-table-column label="操作" width="70" fixed="right"><template slot-scope="{row}"><el-button v-auth="'business:clientAccount:cancel'" type="text" size="small" style="color:#f56c6c;" @click="cancelOrder(row)">撤单</el-button></template></el-table-column>
      </el-table>

      <!-- 交易历史 -->
      <el-table v-if="tab==='deals'" :key="tab" :data="dealList" border size="small" v-loading="loading" style="font-size:13px;">
        <el-table-column prop="deal" label="成交单号" width="90"></el-table-column>
        <el-table-column prop="customerNo" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="name" label="姓名" width="90"></el-table-column>
        <el-table-column prop="countryCode" label="国家" width="90"></el-table-column>
        <el-table-column prop="tradeGroupName" label="交易组别" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="accountNo" label="真实账号" width="100"></el-table-column>
        <el-table-column prop="symbol" label="交易品种" width="90"></el-table-column>
        <el-table-column label="订单类型" width="80"><template slot-scope="{row}">{{ dealEntryLabel(row.entry) }}</template></el-table-column>
        <el-table-column label="买卖方向" width="80"><template slot-scope="{row}"><span :style="{color:row.action===0?'#16a34a':'#dc2626'}">{{ row.action===0?'买入':'卖出' }}</span></template></el-table-column>
        <el-table-column label="手数" width="80"><template slot-scope="{row}">{{ volumeToLots(row.volume) }}</template></el-table-column>
        <el-table-column label="开仓价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.openPrice, row.digits) }}</template></el-table-column>
        <el-table-column label="止损" width="80"><template slot-scope="{row}">{{ fmtPrice(row.priceSL, row.digits) }}</template></el-table-column>
        <el-table-column label="止盈" width="80"><template slot-scope="{row}">{{ fmtPrice(row.priceTP, row.digits) }}</template></el-table-column>
        <el-table-column label="平仓价" width="90"><template slot-scope="{row}">{{ fmtPrice(row.closePrice, row.digits) }}</template></el-table-column>
        <el-table-column label="利息" width="80"><template slot-scope="{row}">{{ (row.storage||0).toFixed(2) }}</template></el-table-column>
        <el-table-column label="手续费" width="80"><template slot-scope="{row}">{{ (row.commission||0).toFixed(2) }}</template></el-table-column>
        <el-table-column label="净盈亏" width="100"><template slot-scope="{row}"><span :style="{color:(row.profit||0)>=0?'#16a34a':'#dc2626'}">{{ (row.profit||0).toFixed(2) }}</span></template></el-table-column>
        <el-table-column label="占用保证金" width="100"><template slot-scope="{row}">{{ (row.margin||0).toFixed(2) }}</template></el-table-column>
        <el-table-column label="开仓时间" width="160"><template slot-scope="{row}">{{ fmtGmt8(row.openTime) }}</template></el-table-column>
        <el-table-column label="成交时间" width="160"><template slot-scope="{row}">{{ fmtGmt8(row.time) }}</template></el-table-column>
      </el-table>

      <!-- 资金流水 -->
      <el-table v-if="tab==='fundFlow'" :key="tab" :data="ffList" border size="small" v-loading="loading" style="font-size:13px;">
        <el-table-column prop="flowNo" label="流水单号" width="150"></el-table-column>
        <el-table-column prop="customerNo" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="name" label="姓名" width="90"></el-table-column>
        <el-table-column prop="countryName" label="国家" width="90"></el-table-column>
        <el-table-column label="交易组别" width="140" show-overflow-tooltip>
          <template slot-scope="{row}"><span v-if="row.accountType===1" style="color:#9ca3af;">--</span><span v-else>{{ row.tradeGroupName || '--' }}</span></template>
        </el-table-column>
        <el-table-column prop="accountNo" label="交易账号" width="100"></el-table-column>
        <el-table-column label="账户类型" width="80">
          <template slot-scope="{row}"><el-tag :type="acctTypeTag(row.accountType)" size="mini">{{ acctTypeLabel(row.accountType) }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="subjectName" label="科目类型" width="100"></el-table-column>
        <el-table-column prop="affectFieldName" label="影响字段" width="80"></el-table-column>
        <el-table-column label="金额(USD)" width="110" align="right">
          <template slot-scope="{row}"><span :style="{fontWeight:500,color:(row.balance||0)>0?'#16a34a':(row.balance||0)<0?'#dc2626':'inherit'}">{{ (row.balance||0)>0?'+':'' }}{{ fmtMoney(row.balance) }}</span></template>
        </el-table-column>
        <el-table-column prop="currency" label="币种" width="70"></el-table-column>
        <el-table-column label="变动前余额" width="110" align="right"><template slot-scope="{row}">{{ fmtMoney(row.balanceBefore) }}</template></el-table-column>
        <el-table-column label="变动后余额" width="110" align="right"><template slot-scope="{row}">{{ fmtMoney(row.balanceAfter) }}</template></el-table-column>
        <el-table-column prop="relatedInfo" label="关联信息" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="relatedGroupNo" label="关联流水组号" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="发生时间" width="160"><template slot-scope="{row}">{{ fmtDateTime(row.createDate) }}</template></el-table-column>
        <el-table-column prop="remark" label="备注" width="200" show-overflow-tooltip></el-table-column>
      </el-table>

      <el-pagination @size-change="(v)=>{pageSize=v;pageNum=1;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[15,30,50]" :page-size="pageSize" layout="total,sizes,prev,pager,next" :total="total" style="margin-top:12px;text-align:right;"></el-pagination>
    </div>
  </div>
</template>

<script>
import { tradingPositions, tradingOrders, tradingDeals, tradingExportPositions, tradingExportOrders, tradingExportDeals, tradingGroupOptions } from '@/api/trading'
import { fundFlowList, fundFlowExport } from '@/api/fundFlow'
import { exchangeProductOptions } from '@/api/tradeProduct'
import { clientAccountSubAccountClosePosition, clientAccountSubAccountCancelOrder } from '@/api/clientAccount'

export default {
  name: 'RealTradeList',
  data() {
    return {
      accountType: 2,
      tab: 'positions',
      loading: false,
      pageNum: 1, pageSize: 15, total: 0,
      search: { customerNo: '', name: '', accountNo: '', symbol: '', groupName: '', action: null, orderNo: '', type: null, typeTime: null, dealType: null, dateRange: null },
      // 资金流水：默认只看真实账户（本页为真实交易），账户类型可切换查看钱包/模拟，清空即全部
      ffSearch: { accountType: 2, subjectType: '', affectField: '' },
      subjectOptions: [
        { code: 1, desc: '存款' }, { code: 2, desc: '人工存款' }, { code: 3, desc: '取款' },
        { code: 4, desc: '转入' }, { code: 5, desc: '转出' }, { code: 6, desc: '开仓佣金' },
        { code: 7, desc: '盈亏' }, { code: 8, desc: '交易编码扣费' }, { code: 9, desc: '交易编码退费' },
        { code: 10, desc: '活动赠金' }, { code: 11, desc: '赠金' }, { code: 12, desc: '奖励送出' },
        { code: 13, desc: '奖励扣回' }, { code: 14, desc: '额度调整' }, { code: 15, desc: '清零' }
      ],
      affectOptions: [{ code: 1, desc: '余额' }, { code: 2, desc: '赠金' }],
      symbolOptions: [], groupOptions: [],
      posList: [], orderList: [], dealList: [], ffList: []
    }
  },
  created() { this.fetchList(); this.fetchOptions() },
  methods: {
    onTabClick() { this.pageNum = 1; this.fetchList() },
    refresh() { this.fetchList() },
    fetchOptions() {
      exchangeProductOptions().then(res => { if (res.code === 0) this.symbolOptions = Array.from(new Set(res.result || [])) })
      tradingGroupOptions({ accountType: this.accountType }).then(res => {
        if (res.code === 0) {
          const seen = new Set()
          this.groupOptions = (res.result || []).filter(g => !seen.has(g.value) && seen.add(g.value))
        }
      })
    },
    handleExport() {
      const params = { ...this.search, ...this.ffSearch }
      // 资金流水用页面上的账户类型筛选（默认真实），其余 tab 固定本页账户类型
      if (this.tab !== 'fundFlow') params.accountType = this.accountType
      if (params.dateRange && params.dateRange.length) { params.startTime = params.dateRange[0]; params.endTime = params.dateRange[1] }
      delete params.dateRange
      const api = this.tab === 'positions' ? tradingExportPositions : (this.tab === 'orders' ? tradingExportOrders : (this.tab === 'deals' ? tradingExportDeals : fundFlowExport))
      const filename = (this.tab === 'positions' ? '真实交易-持仓记录' : this.tab === 'orders' ? '真实交易-委托记录' : this.tab === 'deals' ? '真实交易-交易历史' : '真实交易-资金流水') + '.xlsx'
      api(params).then(res => {
        const blob = res instanceof Blob ? res : new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = filename; a.click()
        URL.revokeObjectURL(url)
      })
    },
    dealEntryLabelFull(t) { const m = {1:'市价开仓',2:'市价平仓',3:'限价开仓',4:'停损开仓',5:'止损平仓',6:'止盈平仓',7:'系统平仓',8:'强制平仓',9:'手动撤单',10:'系统拒绝',11:'系统取消'}; return m[t] || '' },
    searchList() { this.pageNum = 1; this.fetchList() },
    resetSearch() { this.search = { customerNo: '', name: '', accountNo: '', symbol: '', groupName: '', action: null, orderNo: '', type: null, typeTime: null, dealType: null, dateRange: null }; this.ffSearch = { accountType: 2, subjectType: '', affectField: '' }; this.pageNum = 1; this.fetchList() },
    fetchList() {
      this.loading = true
      const params = { pageNum: this.pageNum, pageSize: this.pageSize, ...this.search, ...this.ffSearch }
      // 资金流水用页面上的账户类型筛选（默认真实），其余 tab 固定本页账户类型
      if (this.tab !== 'fundFlow') params.accountType = this.accountType
      if (params.dateRange && params.dateRange.length) { params.startTime = params.dateRange[0]; params.endTime = params.dateRange[1] }
      delete params.dateRange
      const api = this.tab === 'positions' ? tradingPositions : (this.tab === 'orders' ? tradingOrders : (this.tab === 'deals' ? tradingDeals : fundFlowList))
      api(params).then(res => {
        if (res.code === 0) {
          const list = res.result.list || []
          this.total = res.result.total || 0
          if (this.tab === 'positions') this.posList = list
          else if (this.tab === 'orders') this.orderList = list
          else if (this.tab === 'deals') this.dealList = list
          else this.ffList = list
        }
      }).finally(() => { this.loading = false })
    },
    closePosition(row) {
      this.$confirm(`确定平仓 ${row.symbol} 持仓（单号 ${row.position}）吗？`, '平仓确认', { type: 'warning' }).then(() => {
        // 全屏蒙层：平仓请求期间挡住重复点击（同一持仓并发平仓会互相顶掉），
        // 成功/失败都必须关闭，否则失败时蒙层一直挂着挡住整个页面
        const loading = this.$loading({
          lock: true,
          text: '平仓处理中，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        })
        clientAccountSubAccountClosePosition({
          login: row.accountNo, position: row.position, symbol: row.symbol, volume: row.volume, action: row.action
        }).then(res => {
          if (res.code === 0) { this.$message.success('平仓请求已提交'); this.fetchList() }
          else this.$message.error(res.message || '平仓失败')
        }).catch(() => {
          // 请求异常（网络/超时）也要给提示，并同样在 finally 里关掉蒙层
          this.$message.error('平仓失败，请稍后重试')
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {})
    },
    cancelOrder(row) {
      this.$confirm(`确定撤销委托 ${row.symbol}（单号 ${row.order}）吗？`, '撤单确认', { type: 'warning' }).then(() => {
        // 全屏蒙层：撤单请求期间挡住重复点击，成功/失败都要关闭
        const loading = this.$loading({
          lock: true,
          text: '撤单处理中，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        })
        clientAccountSubAccountCancelOrder({
          login: row.accountNo, order: row.order, symbol: row.symbol
        }).then(res => {
          if (res.code === 0) { this.$message.success('撤单请求已提交'); this.fetchList() }
          else this.$message.error(res.message || '撤单失败')
        }).catch(() => {
          this.$message.error('撤单失败，请稍后重试')
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {})
    },
    volumeToLots(v) { return v != null ? (v / 10000) : '-' },
    fmtPrice(p, digits) { return p != null ? p.toFixed(digits != null ? digits : 2) : '-' },
    fmtGmt8(t) {
      if (!t) return '-'
      const d = new Date(String(t).replace(' ', 'T') + (String(t).includes('Z') ? '' : 'Z'))
      if (isNaN(d.getTime())) return t
      d.setUTCHours(d.getUTCHours() + 5)
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getUTCFullYear()}-${p(d.getUTCMonth() + 1)}-${p(d.getUTCDate())} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())}:${p(d.getUTCSeconds())}`
    },
    orderDirectionLabel(t) { const buy = [0,2,4,6]; const sell = [1,3,5,7]; return buy.includes(t) ? '买入' : (sell.includes(t) ? '卖出' : '-') },
    orderTypeLabel(t) { const m = {0:'买入',1:'卖出',2:'买入限价',3:'卖出限价',4:'买入止损',5:'卖出止损',6:'买入停损限价',7:'卖出停损限价',8:'相互平仓'}; return m[t] || (t != null ? t : '-') },
    orderStateLabel(s) { const m = {0:'等待处理',1:'已下单',2:'已取消',3:'部分成交',4:'已成交',5:'已拒绝',6:'已到期'}; return m[s] || (s != null ? s : '-') },
    orderStateType(s) { const m = {0:'info',1:'',2:'info',3:'warning',4:'success',5:'danger',6:'info'}; return m[s] || 'info' },
    // 指定时间/指定日期附上具体到期时刻；未设到期时 MT5 存的是 1970-01-01 哨兵值，不展示
    orderTimeTypeLabel(t, exp) {
      const m = {0:'取消前有效',1:'当天',2:'指定时间',3:'指定日期'}
      const label = m[t] || (t != null ? t : '-')
      if ((t !== 2 && t !== 3) || !exp || String(exp).substring(0, 4) < '1971') return label
      return t === 2 ? `${label}(${this.fmtGmt8(exp)})` : `${label}(${this.expiryDateOnly(exp)})`
    },
    // 指定日期只显示到日：MT5 把「有效至某日」落库为该日次日零点（broker 时间），换算 GMT+8 后减一天即客户所选日
    expiryDateOnly(exp) {
      const s = this.fmtGmt8(exp)
      const d = new Date(s.replace(' ', 'T') + 'Z')
      if (isNaN(d.getTime())) return s
      d.setUTCDate(d.getUTCDate() - 1)
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getUTCFullYear()}-${p(d.getUTCMonth() + 1)}-${p(d.getUTCDate())}`
    },
    dealEntryLabel(e) { const m = {0:'开仓',1:'平仓',2:'反转',3:'对冲平仓'}; return m[e] || (e != null ? e : '-') },
    fmtMoney(v) { return v != null ? Number(v).toFixed(2) : '-' },
    fmtDateTime(t) { return t ? String(t).replace('T', ' ').substring(0, 19) : '-' },
    acctTypeLabel(t) { return { 1: '钱包', 2: '真实', 3: '模拟' }[t] || '-' },
    acctTypeTag(t) { return { 1: 'warning', 2: '', 3: 'info' }[t] || 'info' }
  }
}
</script>

<style scoped>
.page-container { background: #f4f6fb; min-height: calc(100vh - 84px); padding: 16px; }
.table-wrapper { background: #fff; border-radius: 10px; padding: 16px; box-shadow: 0 1px 3px rgba(0,0,0,0.04),0 4px 16px rgba(0,0,0,0.06); }
.table-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.table-title { font-size: 15px; font-weight: 600; color: #1a2236; }
.table-actions { display: flex; gap: 8px; }
.btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 500; cursor: pointer; border: 1px solid transparent; }
.btn-secondary { background: transparent; color: #5a6578; border-color: #e8ecf2; }
.btn-secondary:hover { border-color: #9ca3af; color: #1a2236; }
.btn-sm { padding: 5px 10px; font-size: 12px; }
</style>
